import styled from "@emotion/styled";
import { Link as RouterLink } from "react-router";
import { CircleIconButton } from "../../../buttons/IconButton";
import {
  BORDER_RADIUS_DEFAULT,
  BOX_SHADOW_SMALL,
  COLOR_TERTIARY,
  HEADER_Z_INDEX,
  ICON_PRIMARY_GRADIENT_SELECTED,
  MOBILE_SCREEN,
  SECTION_ACCESS_BLOCKER_BACKGROUND_COLOR_GRADIENT,
} from "../../../theme";
import { PrimaryButton } from "../../../buttons/PrimaryButton";

export const FooterContainer = styled.div`
  min-width: 240px;
`;

export const HelloPrenupLogoWithTextContainer = styled.div`
  margin-top: 4px;
  margin-left: 2px;
  // for a perfect transition
  margin-bottom: -2.5px;
`;

export const IconContainer = styled.div`
  min-width: 20px;
  flex-shrink: 0;
`;

export const Link = styled(RouterLink)`
  text-decoration: none;
  border-radius: 100px;
`;

export const NavLogo = styled.div<{ isExpanded: boolean }>`
  display: flex;
  flex: 0 0 auto;
  min-width: ${(props) => (props.isExpanded ? "168px" : "32px")};
  padding: 24px 0 24px 24px;
`;

export const SignoutAndFooter = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  padding: 0 20px 16px 20px;
  gap: 16px;
`;

export const Spacer = styled.div`
  min-height: 16px;
  height: 16px;
  flex-grow: 1;
`;

export const StyledCircleIconButton = styled(CircleIconButton)`
  margin-bottom: 80px;
`;

export const FilterContainer = styled.div`
  display: inline-flex;
  gap: 16px;
  flex-wrap: wrap;
  ${MOBILE_SCREEN} {
    width: 100%;
    & button {
      padding: 4px 8px;
    }
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 24px;
  padding: 8px 48px;
  height: 56px;
  background-color: ${COLOR_TERTIARY};
  position: fixed;
  top: 0;
  left: max(80px, calc((100vw - 808px) / 4 - 40px));
  right: 0;
  z-index: ${HEADER_Z_INDEX};
  box-shadow: ${BOX_SHADOW_SMALL};
`;

export const AttorneyPhoto = styled.img<{ width: string; height: string }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: 8px;
  object-fit: cover;
`;

export const PrimaryGradientContainer = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: column;
  padding: 32px;
  border-radius: ${BORDER_RADIUS_DEFAULT};
  background: ${ICON_PRIMARY_GRADIENT_SELECTED};
  gap: ${({ gap }) => gap ?? "8px"};
`;

export const StyledAccessBlockerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  margin: 24px 0;
  background: ${SECTION_ACCESS_BLOCKER_BACKGROUND_COLOR_GRADIENT};
  border-radius: 16px;
  box-shadow: ${BOX_SHADOW_SMALL};
`;

export const StyledAccessBlockerHeader = styled(Header)`
  margin-bottom: 16px;
`;

export const StyledAccessBlockerButton = styled(PrimaryButton)`
  margin-top: 24px;
`;
